export default "__VITE_ASSET__Xz_twkNg__"